import { Location } from 'history';
import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideLoading, showLoading } from '../../reducers/app';
import Modal from "../common/Modal/Modal";

interface Props {
  when?: boolean 
  navigate: (path: string) => void;
  shouldBlockNavigation: (location: Location) => boolean;
  mutation: any;
  values: any;
}

const RouteLeavingGuard = ({
  when,
  navigate,
  shouldBlockNavigation,
  mutation,
  values
}: Props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const [error, setError] = useState(false);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const closeModal = () => {
    setModalVisible(false);
  };
  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };
  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    dispatch(showLoading());
    mutation(values).then(() => {
      setConfirmedNavigation(true);
      dispatch(hideLoading());
    }).catch((e: any) => {
      dispatch(hideLoading());
      setError(true);
      setModalVisible(true);
      console.log(e)
    });
  };
  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      navigate(lastLocation.pathname);
    }
  }, [confirmedNavigation, lastLocation, navigate]);
  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      {/* Your own alert/dialog/modal component */}
      <Modal
        icon={error ? "gc-icon-functional-attention-2-col" : "gc-icon-functional-question-2-col" }
        show={modalVisible}
        onClose={closeModal}
        descriptionClass={"success-modal-text paragraph-main-fs8"}
        content={error ? t("common.case.incomplete.generic.error")
          : (
          <>
            {t("common.cases.incomplete.content.modal.text")}
            <span className="bold">
              {` ${t('common.cases.incomplete.content.modal.sub_text')}`}
            </span>
          </>
          )
        }
        type={"button"}
        linkTitle={t("common.case.incomplete.closeModal")}
        onFirstClick={closeModal}
        typeSecond={"button"}
        styleTypeSecond={"secondary"}
        linkTitleSecond={t("common.cases.incomplete.save")}
        onSecondClick={handleConfirmNavigationClick}
      />
    </>
  );
};
export default RouteLeavingGuard;
